// Alias
import Menu from '../private/menu';
export default Menu;